module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/adequate-root-filling-density.9a93297b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/adequate-root-filling-density.png
// module id = 301
// module chunks = 0